// extracted by mini-css-extract-plugin
export default {"button":"UniversalButton_button__ymTr8"};